export const projects = [
  {
    id: 'enez',
    title: 'Enez Villaları',
    location: 'Enez, Edirne',
    status: 'Yapım Aşamasında - Satışta',
    statusColor: 'amber',
    description:
      'Doğayla iç içe, denize yakın 36 özel villadan oluşan lüks yaşam ve yatırım projesi.',
    coverImage: '/media/enez-hero.webp',
    coverImageAlt: 'Enez Villaları - Nosta Yapı Lüks Villa Projesi',
    videoId: 'jT9ebWaELj0',
    galleryTabs: [
      {
        tabName: 'Bittiğinde Nasıl Görünecek? (Render)',
        images: [
          {
            url: '/media/enez-hero.webp',
            title: '',
            alt: 'Enez Satılık Lüks Villa Dış Cephe Tasarımı',
          },
          {
            url: '/media/enez-01.webp',
            title: '',
            alt: 'Enez Villaları Modern Mimari Tasarım',
          },
          {
            url: '/media/enez-02.webp',
            title: '',
            alt: 'Lüks Villa Bahçe ve Açık Alan',
          },
          {
            url: '/media/enez-03.webp',
            title: '',
            alt: 'Enez Villaları İç Mekan Tasarım',
          },
          {
            url: '/media/enez-04.webp',
            title: '',
            alt: 'Nosta Yapı Lüks Konut Projesi',
          },
          {
            url: '/media/enez-05.webp',
            title: '',
            alt: 'Enez Villaları Şantiye Görseli',
          },
        ],
      },
      {
        tabName: 'İnşaat Süreci ve Güncel Durum',
        images: [
          {
            url: '/media/enez-site-01.webp',
            title: '',
            alt: 'Enez Villaları İnşaat Aşaması',
          },
          {
            url: '/media/enez-site-02.webp',
            title: '',
            alt: 'Şantiyede Temel Çalışmaları',
          },
          {
            url: '/media/enez-site-03.webp',
            title: '',
            alt: 'Villa Yapısı İnşaat Gelişimi',
          },
          {
            url: '/media/enez-site-04.webp',
            title: '',
            alt: 'Nosta Yapı İnşaat Kalite Kontrol',
          },
          {
            url: '/media/enez-site-05.webp',
            title: '',
            alt: 'Enez Villaları Güncel Durum Fotoğrafı',
          },
          {
            url: '/media/enez-site-06.webp',
            title: '',
            alt: 'Lüks Villa İnşaat Detayları',
          },
        ],
      },
      {
        tabName: 'Kat ve Vaziyet Planları',
        images: [
          {
            url: '/media/enez-plan-vaziyet.webp',
            title: 'Vaziyet Planı (Site Yerleşimi)',
            alt: 'Enez Villaları Site Vaziyet Planı ve Yerleşimi',
          },
          {
            url: '/media/enez-plan-zemin.webp',
            title: 'Zemin Kat Planı (Salon + Mutfak)',
            alt: 'Villa Zemin Kat Planı - Salon Mutfak Tasarımı',
          },
          {
            url: '/media/enez-plan-1.webp',
            title: '1. Kat Planı (Yatak Odaları)',
            alt: '1. Kat Planı - Yatak Odaları ve Banyo Tasarımı',
          },
          {
            url: '/media/enez-plan-teras.webp',
            title: 'Teras Katı Planı',
            alt: 'Teras Katı Planı - Açık Alan ve Teras Tasarımı',
          },
        ],
      },
    ],
  },
  {
    id: 'bayramoglu',
    title: 'Bayramoğlu Ada Konutları',
    location: 'Bayramoğlu, Darıca',
    status: 'Tamamlandı - Yaşam Başladı',
    statusColor: 'green',
    description:
      'Zamanında teslim edilen, modern mimarisiyle bölgeye değer katan referans projemiz.',
    coverImage: '/media/bayramoglu-01.webp',
    coverImageAlt: 'Bayramoğlu Ada Konutları - Nosta Yapı Tamamlanmış Proje',
    simpleGallery: [
      {
        url: '/media/bayramoglu-01.webp',
        title: '',
        alt: 'Bayramoğlu Ada Konutları Kompleksi',
      },
      {
        url: '/media/bayramoglu-02.webp',
        title: '',
        alt: 'Bayramoğlu Konutları Modern Tasarım',
      },
    ],
  },
];

export const companyInfo = {
  name: 'NOSTA YAPI',
  logoUrl: '/logo.png',
  // Sitedeki ana iletişim numarası. WhatsApp butonu da bunu kullanır.
  phone: '0538 562 34 42',
  address:
    'Barbaros Hayrettin Paşa Mah. 1994. Sok. No:2 İç Kapı No:111 (Çebi Natura Green Office) Esenyurt / İSTANBUL',
  email: 'info@nostayapi.com',
  team: [
    {
      name: 'Turhan Kağan Akın',
      title: 'Yüksek İnşaat Mühendisi',
      phone: '0538 562 34 42',
      role: 'Teknik Ofis',
    },
    {
      name: 'Mehmet Batuhan Akın',
      title: 'Mimar',
      phone: '0535 043 26 00',
      role: 'Mimari Proje',
    },
  ],
};

// '0538 562 34 42' -> '905385623442'
export const whatsappNumber = '90' + companyInfo.phone.replace(/\D/g, '').slice(1);

export const navLinks = [
  { label: 'Anasayfa', section: 'home' },
  { label: 'Projeler', section: 'projects' },
  { label: 'Kurumsal', section: 'about' },
  { label: 'İletişim', section: 'contact' },
];
